module.exports = __webpack_public_path__ + "static/media/battery-charge.d49fbc43.png";